var personFemale=[
  {
    "id": 21,
    "name": "Alina Gomes",
    "img": "https://i.pinimg.com/originals/77/71/68/7771683223d86b237a3304d6f32828b9.jpg",
    "title": "Graphic Designer",
    "phone": "01326-XXXXXX",
    "email": "alina123@gmail.com",
    "site": "www.alinapro.com",
    "dob": "Aug 23,1999",
    "address": "Sabish, Ragina, Kanada",
    "hobby1": "Drawing",
    "hobby2": "Reading book",
    "hobby3": "planting",
    "skill1": "Adobe Photoshop",
    "skill2": "Adobe Illustrator",
    "skill3": "CSS",
    "income": "35000"
  },
  {
    "id": 22,
    "name": "Dipika Padhokon",
    "img": "https://www.brisbaneheadshots.com.au/images/galleries/women-corporate/Asian-headshots-linkedin-profile-brisbane.jpg",
    "title": "Web Developer",
    "phone": "+8601449-XXXXXX",
    "email": "dipika@outlook.com",
    "site": "www.dipikapad.com",
    "dob": "Jun 30,1987",
    "address": "Delhi, India",
    "hobby1": "Movie",
    "hobby2": "Traveling",
    "hobby3": "Acting",
    "skill1": "Acting",
    "skill2": "Producers",
    "skill3": "Film maker",
    "income": "50000"
  },
  {
    "id": 23,
    "name": "Abdur Rahman",
    "img": "http://images.unsplash.com/photo-1534308143481-c55f00be8bd7?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyMDd9",
    "title": "Web Designer",
    "phone": "+890656-XXXXXX",
    "email": "abdur12345@gmail.com",
    "site": "www.abdurdev.xyz",
    "dob": "Mar 30,1995",
    "address": "Korachi, Pakistan",
    "hobby1": "Typing",
    "hobby2": "Walking",
    "hobby3": "Gardening",
    "skill1": "c#",
    "skill2": "css",
    "skill3": "javascript",
    "income": "20000"
  },
  {
    "id": 24,
    "name": "Badang tong",
    "img": "https://www.bing.com/th?id=OIP.v53Yrpa3p7OoZY-JebtXwwHaE8&pid=Api&rs=1",
    "title": "Software Engineer",
    "phone": "+121293-XXXXXX",
    "email": "badag1998@gmail.com",
    "site": "www.tongwebsite.com",
    "dob": "Feb, 20,1998",
    "address": "Shanti, Myanmar",
    "hobby1": "Making Software",
    "hobby2": "Gaming",
    "hobby3": "Reading story",
    "skill1": "c++",
    "skill2": "html",
    "skill3": "Java",
    "income": "10000"
  },
  {
    "id": 25,
    "name": "Salina Ahammed",
    "img": "https://images.squarespace-cdn.com/content/541a0730e4b000f167faa35c/1468616750643-FOJ79V3GUIQYEE0Z7PS8/VP+Leni+Profile.jpg?content-type=image%2Fjpeg",
    "title": "Student",
    "phone": "01526-XXXXXX",
    "email": "ahammedsalina@gmale.com",
    "site": "www.salinastu.xyz",
    "dob": "Aug 6,1999",
    "address": "Feni, Bangladesh",
    "hobby1": "Gaming",
    "hobby2": "Reading book",
    "hobby3": "Cricket",
    "skill1": "Football",
    "skill2": "css",
    "skill3": "painting",
    "income": "10000"
  },
  {
    "id": 26,
    "name": "Abu Lahab",
    "img": "http://thispix.com/wp-content/uploads/2015/06/015.jpg",
    "title": "web designer",
    "phone": "+98626-XXXXXX",
    "email": "lahab344@outlook.com",
    "site": "www.abupro.xyz",
    "dob": "Aug 6,1999",
    "address": "Kalkata, India",
    "hobby1": "Gaming",
    "hobby2": "Reading book",
    "hobby3": "Cricket",
    "skill1": "Playing",
    "skill2": "Cooking",
    "skill3": "Writing",
    "income": "10000"
  },
  {
    "id": 27,
    "name": "Md Mazid",
    "img": "http://api.ning.com/files/3xh5OKLELdmunxUkiaqtIRfQ5ExlXCrJ85pKr3jGnbtvlRubARY5VrFNK8TmRXit182qWa1q1WZg-IU*cwBYaFQ-74ff0zW6/Passportsizephoto.JPG?profile=RESIZE_710x&height=508",
    "title": "web designer",
    "phone": "+12326-XXXXXX",
    "email": "mazid344@outlook.com",
    "site": "www.mazid.com",
    "dob": "Aug 6,1993",
    "address": "Damisko, Iran",
    "hobby1": "Making new thing",
    "hobby2": "Reading book",
    "hobby3": "Cricket",
    "skill1": "python",
    "skill2": "css",
    "skill3": "html",
    "income": "80000"
  },
  {
    "id": 28,
    "name": "Mis Habibi",
    "img": "https://www.bing.com/th?id=OIP.bSf9Cw3EsdUdna1jVoPKBwHaKj&pid=Api&rs=1",
    "title": "Graphic designer",
    "phone": "+8801226-XXXXXX",
    "email": "habibi344@gmail.com",
    "site": "www.habibi.xyz",
    "dob": "Aug 6,1989",
    "address": "Washington, USA",
    "hobby1": "Gaming",
    "hobby2": "Writing book",
    "hobby3": "Cricket",
    "skill1": "python",
    "skill2": "css",
    "skill3": "html",
    "income": "25000"
  },
  {
    "id": 29,
    "name": "Aisha Akter",
    "img": "https://www.bing.com/th?id=OIP.lcoXyLCCGUrbtuvA-TsazgHaHb&pid=Api&rs=1",
    "title": "House wife",
    "phone": "01726-XXXXXX",
    "email": "aisha344@outlook.com",
    "site": "www.aisha.xyz",
    "dob": "Aug 6,1999",
    "address": "Korachi, Pakistan",
    "hobby1": "Gaming",
    "hobby2": "Reading book",
    "hobby3": "Cricket",
    "skill1": "Cooking",
    "skill2": "Teaching",
    "skill3": "Drawing",
    "income": "20000"
  },
  {
    "id": 30,
    "name": "Masuma Khatun",
    "img": "http://www.pngall.com/wp-content/uploads/2016/06/Consultant-Free-PNG-Image.png",
    "title": "web designer",
    "phone": "+88026-XXXXXX",
    "email": "masuma344@gmail.com",
    "site": "www.masuma.xyz",
    "dob": "Aug 6,1997",
    "address": "Barishal, Bangladesh",
    "hobby1": "Gaming",
    "hobby2": "Reading book",
    "hobby3": "Cricket",
    "skill1": "python",
    "skill2": "css",
    "skill3": "html",
    "income": "50000"
  },
  {
    "id": 31,
    "name": "Md Shuvo",
    "img": "https://www.bing.com/th/id/OIP.XariU8CrsPPTCMwSkSnNigHaLH?pid=Api&rs=1",
    "title": "Graphic designer",
    "phone": "+98125-XXXXXXx",
    "email": "shuvo5555@gmail.com",
    "site": "www.shuvodev.com",
    "dob": "Jan 10, 1988",
    "address": "All-ain, Dubai",
    "hobby1": "Drawing picture",
    "hobby2": "making new thing",
    "hobby3": "Reading Book",
    "skill1": "HTML",
    "skill2": "CSS",
    "skill3": "Adobe Photoshop",
    "income": "30000"
  },
  {
    "id": 32,
    "name": "Soyaiba Jannath",
    "img": "https://www.bing.com/th/id/OIP.Wh-_Vqn3Ovtl3dlddA2acAHaE7?pid=Api&rs=1",
    "title": "Web designer",
    "phone": "+32123-XXXXX",
    "email": "jannath12345@gmail.com",
    "site": "www.jannathpro.com",
    "dob": "Feb 20, 1995",
    "address": "Mokka, Soudi",
    "hobby1": "Writing book",
    "hobby2": "Gaming",
    "hobby3": "Reading Book",
    "skill1": "HTML",
    "skill2": "JAVA",
    "skill3": "C++",
    "income": "10000"
  },
  {
    "id": 33,
    "name": "Mashrafi Mortuza",
    "img": "https://www.bing.com/th/id/OIP.UyMnXOAasjuyiwjtH0z62QAAAA?pid=Api&rs=1",
    "title": "Crickter",
    "phone": "+88172-XXXXX",
    "email": "mas.cricket@gmail.com",
    "site": "www.mashpro.com",
    "dob": "Jun 29,1988",
    "address": "Dhaka, Bangladesh",
    "hobby1": "Playing",
    "hobby2": "Watching Movie",
    "hobby3": "Reading Book",
    "skill1": "Cricket",
    "skill2": "Driving",
    "skill3": "Singing",
    "income": "80000"
  },
  {
    "id": 34,
    "name": "Sakira Jannath",
    "img": "https://www.bing.com/th/id/OIP.UlO6mbXTdKaMyiBJf3RwrAHaE8?pid=Api&rs=1",
    "title": "Web Designer",
    "phone": "+8801726-XXXXXX",
    "email": "sakira344@outlook.com",
    "site": "www.sakira.xyz",
    "dob": "Aug 6,1999",
    "address": "Bagha, Rajshahi, Bangladesh",
    "hobby1": "Gaming",
    "hobby2": "Reading book",
    "hobby3": "Cricket",
    "skill1": "python",
    "skill2": "css",
    "skill3": "html",
    "income": "35000"
  },
]
export default personFemale;